import { getContactSchema } from "./contactSchema";
import { api } from "../../common/utils/api";
import { executeRecaptcha } from "../../common/utils/recaptcha";

export const initContactForm = () => {
  const container = document.getElementById("contact-form-container");
  const form = container?.querySelector<HTMLFormElement>(".cf-form");
  const translations =
    (window as any).commonVariables?.translations?.contactForm || {};

  if (!form || !container) return;

  const fieldset = form.querySelector("fieldset");
  const submitBtn = form.querySelector<HTMLButtonElement>(".cf-form__submit");
  const errorAlert = form.querySelector<HTMLElement>(".cf-form__alert--error");
  const originalBtnText = submitBtn?.innerHTML || "";

  const clearErrors = () => {
    form
      .querySelectorAll(".cf-field__input")
      .forEach((el) => el.classList.remove("has-error"));
    form
      .querySelectorAll(".cf-field__error")
      .forEach((el) => (el.textContent = ""));
    if (errorAlert) {
      errorAlert.style.display = "none";
      errorAlert.innerHTML = "";
    }
  };

  const setFieldError = (fieldName: string, message: string) => {
    const input = form.querySelector(`[name="${fieldName}"]`);
    const errorDiv = input
      ?.closest(".cf-field")
      ?.querySelector(".cf-field__error");
    if (input && errorDiv) {
      input.classList.add("has-error");
      errorDiv.textContent = message;
    }
  };

  const renderSuccessState = () => `
    <div class="cf-success-state">
      <div class="cf-success-state__icon">
        <svg class="icon icon--stroke-thick"><use xlink:href="#icon-check"></use></svg>
      </div>
      <h3 class="cf-success-state__title">${translations.successTitle || "Teşekkürler!"}</h3>
      <p class="cf-success-state__message">${translations.successMessage || "Mesajınız alındı."}</p>
    </div>
  `;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    clearErrors();

    const formData = new FormData(form);
    const rawData = Object.fromEntries(formData.entries());

    const result = getContactSchema().safeParse(rawData);

    if (!result.success) {
      result.error.flatten().formErrors.forEach((msg) => {
        if (errorAlert) {
          errorAlert.style.display = "block";
          errorAlert.innerHTML += `<span>${msg}</span>`;
        }
      });
      Object.entries(result.error.flatten().fieldErrors).forEach(
        ([field, msgs]) => {
          if (msgs) setFieldError(field, msgs[0]);
        },
      );
      return;
    }

    if (fieldset) fieldset.disabled = true;
    if (submitBtn) {
      submitBtn.innerHTML = `<span>${translations.sending || "Gönderiliyor..."}</span>`;
    }

    try {
      const recaptchaToken = await executeRecaptcha("contact_form");

      const payload = {
        ...result.data,
        recaptcha_token: recaptchaToken,
      };

      // Contact endpoint'ine atıyoruz
      await api.post("/forms/contact", payload);

      container.innerHTML = renderSuccessState();
      container.scrollIntoView({ behavior: "smooth", block: "center" });

      if (typeof (window as any).gtag === "function") {
        (window as any).gtag("event", "generate_lead", {
          form_type: "Contact Page Form",
        });
      }
    } catch (err: any) {
      if (fieldset) fieldset.disabled = false;
      if (submitBtn) submitBtn.innerHTML = originalBtnText;

      if (errorAlert) {
        errorAlert.style.display = "flex";
        errorAlert.innerHTML = `<span>${err.message || translations.errorGeneral || "Hata oluştu."}</span>`;
      }
    }
  });
};
